export default function Swatch({ name, hex, active, onClick, testid }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      title={name}
      className="flex flex-col items-center gap-2.5 group focus:outline-none transition-transform duration-200 hover:scale-[1.05]"
    >
      <span
        className={`swatch-ring block h-12 w-12 md:h-14 md:w-14 rounded-full transition-shadow duration-200 group-hover:shadow-md ${active ? "active" : ""}`}
        style={{ background: hex }}
      />
      <span
        className={`text-[0.62rem] uppercase tracking-[0.14em] ${
          active ? "text-[var(--ark-accent)]" : "text-[var(--ark-muted)]"
        } group-hover:text-[var(--ark-black)] transition-colors`}
      >
        {name}
      </span>
    </button>
  );
}
